<script setup lang="ts">
import { PropertyId } from "~/classes/entity"

const props = defineProps({
  fileId: null
})

const { state: viewModeState, previewScale } = useViewMode()
const { isSelectedIn } = useSelection()
const { currentOpenFolders } = useNavigation()
const { fileIdAttr } = useGlobals()
const { getReactiveFile } = useCollectionView()

const reactiveFile = getReactiveFile(props.fileId, "collection-view")!

if (!reactiveFile)
  throw new Error("Must not instantiate CollectionTreeFile without a reactive file")

const file = reactiveFile.ref()

const selected = computed(() => isSelectedIn(props.fileId, "collection-view"))
const open = computed(() => currentOpenFolders.value[props.fileId])
const previewWidth = computed(() => {
  const scale = previewScale.value
  const width = 2 ** (2.6 + 5 * scale)
  return width
})
const properties = computed(
  () => viewModeState
    .value
    .current
    .show
    .filter(p => p.propertyId !== PropertyId.FILE_VIRTUAL_PREVIEW)
    .filter(p => file.value.hasProperty(p.propertyId)),
)
</script>

<template>
  <div v-if="file">
    <div
      class="tree-item"
      :class="{ selected, open }"
      :[dataAttr(fileIdAttr)]="file.id"
    >
      <div class="tree-folder-chevron">
        <collection-tree-chevron v-if="file.isFolder()" :open />
      </div>
      <div class="tree-item-container">
        <div :style="{ width: px(previewWidth), height: px(previewWidth) }" class="tree-file-icon">
          <file-thumbnail
            :file

            shadowed
            :container-width="previewWidth"
            :container-height="previewWidth"
          />
        </div>
        <!-- <div class="tree-file-text">
          {{ file.name() }}
        </div> -->
        <div class="tree-properties">
          <file-decal :file :selected />
          <file-property-view
            v-for="{ propertyId, size, color } in properties"
            :key="propertyId"
            :property-id
            :size
            :reactive-file
            :color
            :selected
            text-alignment="left"
          />
        </div>
      </div>
    </div>
    <div v-if="open" class="tree-item-contents">
      <collection-tree-list :parent-id="file.id" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.tree-item
  @apply flex items-center w-full
.tree-item-container
  @apply flex items-center max-w-full overflow-hidden cursor-pointer

.tree-folder-chevron
  @apply flex-none w-4 h-4 flex items-center justify-center
.tree-file-icon
  @apply flex-none flex items-center justify-center
.tree-properties
  @apply flex items-center gap-[2px]
.tree-file-text
  @apply break-words overflow-hidden whitespace-nowrap text-ellipsis

.tree-item-contents
  @apply ml-4
</style>
